import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import type { ReactNode } from "react";
import Topbar from "./Topbar";

interface ILayoutProps {
    children: ReactNode;
}

const Layout: React.FC<ILayoutProps> = ({ children }) => {
    const location = useLocation();

    const noTopbarRoutes = ["/login", "/register"];
    const isHome = location.pathname === "/";
    const shouldShowTopbar = !noTopbarRoutes.includes(location.pathname);

    return (
        <>
            {shouldShowTopbar && !isHome && <Topbar />}
            <Box>{children}</Box>
        </>
    );
};

export default Layout;
